module.exports = __webpack_public_path__ + "static/media/events-icon-active-text.ee9cc229.png";